import { render, staticRenderFns } from "./AllowanceBudgetProgressbar.vue?vue&type=template&id=5619f10c&lang=pug&"
import script from "./AllowanceBudgetProgressbar.vue?vue&type=script&lang=js&"
export * from "./AllowanceBudgetProgressbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports